"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.VehiclesCompareSectionV2 = exports.VehiclesCompareSectionReducersV2 = void 0;
var _vehicleCompareContainerV = _interopRequireDefault(require("./components/containers/vehicle-compare-container-v2"));
exports.VehiclesCompareSectionV2 = _vehicleCompareContainerV["default"];
var _reducers = require("./redux/reducers");
exports.VehiclesCompareSectionReducersV2 = _reducers.VehiclesCompareSectionReducersV2;